import React from 'react';
import Slider from 'react-slick';
import personeImg1 from '../../assets/testimonials/person-1.png';
import personeImg2 from '../../assets/testimonials/person-1.png'; // Add correct images
import personeImg3 from '../../assets/testimonials/person-1.png'; // Add correct images

// Custom left arrow component
const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div id='testimonials' className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer z-10" onClick={onClick}>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="28" cy="28" r="28" fill="white" />
                <circle cx="28" cy="28" r="27" stroke="#596179" strokeOpacity="0.1" strokeWidth="2" />
                <path d="M40 19.1665V35.8332" stroke="#77808C" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" />
                <path d="M16 27.833H27.3333" stroke="#77808C" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" />
                <path d="M28 20.5L34.6667 27.5L28 34.5" stroke="#959AA8" strokeWidth="2" strokeLinecap="round" />
            </svg>
        </div>
    );
};

// Custom right arrow component
const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 cursor-pointer z-10" onClick={onClick}>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="28" cy="28" r="28" transform="matrix(-1 0 0 1 56 0)" fill="white"/>
                <circle cx="28" cy="28" r="27" transform="matrix(-1 0 0 1 56 0)" stroke="#596179" stroke-opacity="0.1" stroke-width="2"/>
                <path d="M16 19.1665V35.8332" stroke="#77808C" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round"/>
                <path d="M40 27.833H28.6667" stroke="#77808C" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round"/>
                <path d="M28 20.5L21.3333 27.5L28 34.5" stroke="#959AA8" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </div>
    );
};

export default function Testimonials() {
    const testimonialData = [
        {
            name: 'R.M',
            title: 'Real Estate Developer',
            company: 'Mercedes',
            img: personeImg1,
            quote: '“The no-code setup and free credits allowed us to test before committing. Regular updates keep us ahead, and the ability to use our own numbers is a huge plus. Highly recommend for seamless customer experience!”'
        },
        {
            name: 'H.Y',
            title: 'Automotive Brand',
            company: 'TechCorp',
            img: personeImg2,
            quote: '“1Confirmed has been a game-changer. Simplified notifications and broadcasts have improved our customer interactions. The no-code platform and customizable templates make it easy to tailor to our needs for both sales and after-sales. A must-have tool for any business!”'
        },
        {
            name: 'T.AT.A',
            title: 'Digital Agency',
            company: 'BizInc',
            img: personeImg3,
            quote: '“We had a client suffering from fake and bad reviews. With 1Confirmed we could add hundreds of real reviews improving the Google Reviews rating from 3.9 to 4.2 in only 3 weeks. Now we use 1Confirmed for almost every problem expressed by our clients.”'
        },
        {
            name: 'F.B',
            title: 'Real Estate Agency',
            company: 'BizInc',
            img: personeImg3,
            quote: '“With the help of 1Confirmed Whatsapp Business APIs we created the most powerful Real Estate chatbot linking our Chatbot to our Website and managing both through the same CMS. Thank you for making Lead qualification easier using WhatsApp and Artificial Intelligence.”'
        },
        {
            name: 'I.E',
            title: 'E-Commerce merchant',
            company: 'BizInc',
            img: personeImg3,
            quote: '“Orders Confirmation has never been easier, All we have to do now is to upload our leads in an excel file and 1Confirmed will take care of confirming the orders. The Whatsapp Business APIs helped us automate all confirmations notifications processes.”'
        },
    ];

    const settingsSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <div className='bg-[#F3F8FF] pt-[83px] pb-[133px] text-4xl relative'>
            <h3 className='text-center font-bold text-[#19223E]'>Testimonials</h3>
            <div className="container mt-20">
                <Slider {...settingsSlider}>
                    {testimonialData.map((testimonial, index) => (
                        <div key={index} className='flex justify-center'>
                            <div className='md:max-w-[889px] rounded-[10px] py-8 px-6 bg-white mx-auto'>
                                <div className="flex flex-col items-center">
                                    <div className="max-md:order-1 max-sm:order-2 max-sm:mt-4 flex items-center mb-6">
                                        {/* <img src={testimonial.img} alt={testimonial.name} className="w-16 h-16 rounded-full" /> */}
                                        <div className="mx-2 md:text-center max-sm:text-left">
                                            <h3 className='text-start text-base font-bold'>{ testimonial.name }</h3>
                                            {/* <span className='font-bold'>{testimonial.company}</span> */}
                                            <p className='text-base'>{testimonial.title}</p>
                                        </div>
                                    </div>
                                    <p className='mt-7 text-center'>{ testimonial.quote }</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}
